import { useCallback, useEffect } from 'react';
import { createSelector } from 'reselect';

import { useSelector, useDispatch } from '../../../react-redux';
import { updateAgentGroupsAction } from '../../../reducers/agent';

import { getAgentGroupsApi } from './api';

// 模块级标记，防止并发/重复请求
let hasFetched = false;

const createWithoutBotGroup = () =>
  createSelector([agentGroup => agentGroup], agentGroup => {
    return agentGroup.filter(
      value =>
        !['__SMARTGUIDE_ROBOTS__', '__MPUSH_ROBOTS__', '__ROBOTS__ ', '__ROBOTS__', '__EXTERNAL_ROBOTS__'].includes(
          value.name
        )
    );
  });

const withoutSmartGuideGroup = createSelector([agentGroup => agentGroup], agentGroup => {
  return agentGroup.filter(value => !['__SMARTGUIDE_ROBOTS__', '__ROBOTS__', '__ROBOTS__ '].includes(value.name));
});

const withExBotGroup = createSelector([agentGroup => agentGroup], agentGroup => {
  return agentGroup.filter(
    value => !['__SMARTGUIDE_ROBOTS__', '__MPUSH_ROBOTS__', '__ROBOTS__ ', '__ROBOTS__'].includes(value.name)
  );
});

const textMap = {
  __MPUSH_ROBOTS__: 'AI数字员工组',
  '__ROBOTS__ ': '机器人',
  __ROBOTS__: '机器人',
  __SMARTGUIDE_ROBOTS__: '智能引导机器人组',
  __EXTERNAL_ROBOTS__: '外部机器人'
};

function mapBotName(group) {
  return {
    ...group,
    name: textMap[group.name] || group.name,
    prevName: group.name
  };
}

const parsedName = createSelector([agentGroup => agentGroup], agentGroup => {
  return agentGroup.map(value => ({
    ...value,
    name: textMap[value.name] || value.name,
    prevName: value.name
  }));
});

const withoutBotGroup = createWithoutBotGroup();

const useAgentGroups = () => {
  const agentGroupAll = useSelector(state => state.getIn(['agent', 'agentGroupsList']));
  const agentGroupList = withoutBotGroup(agentGroupAll);
  const agentGroupWithExBotList = withExBotGroup(agentGroupAll).map(mapBotName);
  const agentGroupWithoutSmartGuideList = withoutSmartGuideGroup(agentGroupAll).map(mapBotName);

  const dispatch = useDispatch();

  const getAgentGroupList = useCallback(async () => {
    const { data } = await getAgentGroupsApi();
    if (data) {
      const { agent_groups = [] } = data;
      dispatch(updateAgentGroupsAction(() => agent_groups));
    }
  }, []);

  // 按需自动加载：首次有组件使用 useAgentGroups 时触发，全局只请求一次
  useEffect(() => {
    if (hasFetched) return;
    hasFetched = true;
    getAgentGroupList().catch(() => {
      hasFetched = false;
    });
  }, []);

  return {
    agentGroupAll: parsedName(agentGroupAll),
    agentGroupList,
    getAgentGroupList,
    agentGroupWithExBotList,
    agentGroupWithoutSmartGuideList,
    withoutSmartGuideGroup
  };
};

export default useAgentGroups;
